import { useDataMapping } from "./DataMappingContext";

export function useWorkingPanel() {
  const { state, dispatch } = useDataMapping();
  return {
    ...state.workingPanel,
    togglePanel: () => dispatch({ slice: "workingPanel", type: "TOGGLE_PANEL" }),
    setStage: (stage) => dispatch({ slice: "workingPanel", type: "SET_STAGE", stage }),
    setDataframes: (dataframes) =>
      dispatch({ slice: "workingPanel", type: "SET_DATAFRAMES", dataframes }),
    setSelectedKey: (key) =>
      dispatch({ slice: "workingPanel", type: "SET_SELECTED_KEY", key }),
    setSelectedOutputKey: (key) =>
      dispatch({ slice: "workingPanel", type: "SET_SELECTED_OUTPUT_KEY", key }),
    setTableData: (data) => dispatch({ slice: "workingPanel", type: "SET_TABLE_DATA", data }),
    setPage: (page) => dispatch({ slice: "workingPanel", type: "SET_PAGE", page }),
    setTotalPages: (totalPages) =>
      dispatch({ slice: "workingPanel", type: "SET_TOTAL_PAGES", totalPages }),
    setLoadingList: (loading) =>
      dispatch({ slice: "workingPanel", type: "SET_LOADING_LIST", loading }),
    setLoadingData: (loading) =>
      dispatch({ slice: "workingPanel", type: "SET_LOADING_DATA", loading }),
    triggerRefresh: () => dispatch({ slice: "workingPanel", type: "TRIGGER_REFRESH" }),
    selectColumn: (index, extend, toggle) =>
      dispatch({ slice: "workingPanel", type: "SELECT_COLUMN", index, extend, toggle }),
    selectRow: (index, extend, toggle) =>
      dispatch({ slice: "workingPanel", type: "SELECT_ROW", index, extend, toggle }),
    selectCell: (row, col, extend, toggle) =>
      dispatch({ slice: "workingPanel", type: "SELECT_CELL", row, col, extend, toggle }),
    clearSelection: () => dispatch({ slice: "workingPanel", type: "CLEAR_SELECTION" }),
    setCharts: (charts) => dispatch({ slice: "workingPanel", type: "SET_CHARTS", charts }),
    setLoadingCharts: (loading) =>
      dispatch({ slice: "workingPanel", type: "SET_LOADING_CHARTS", loading }),
    refreshCharts: () => dispatch({ slice: "workingPanel", type: "REFRESH_CHARTS" }),
    chartCreated: () => dispatch({ slice: "workingPanel", type: "CHART_CREATED" }),
    outputCreated: () => dispatch({ slice: "workingPanel", type: "OUTPUT_CREATED" }),
  };
}
